// ViewSalesInvoiceDetails.js
import React, { useState, useEffect } from "react";
// import {
//   ThermalPrinter,
//   PrinterTypes,
//   CharacterSet,
// } from "react-thermal-printer";
import { useNavigationEvent } from "navigation-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPrint,
  faArrowLeft,
  faTimesCircle,
  faSpinner,
  faMessage,
  faEnvelope,
  faSms,
  faPlus,
  faBook,
  faClose,
  faHistory,
  faRemove,
} from "@fortawesome/free-solid-svg-icons";
import useSWR from "swr";
import mainLogo from "./images/mainlogo.png";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import TopActionMenus from "./TopActionMenus";
import SecureLS from "secure-ls";
import { pdf } from "@react-pdf/renderer";
import PaymentModal from "./PaymentModal";
import PaymentHistory from "./PaymentHistory";
// import InvoicePdf from "./InvoicePdf";
import InvoiceReceiptPdf from "./InvoiceReceiptPdf";

const ls = new SecureLS({ encodingType: "aes" });
const username = "admin1";
const password = "abc@123@Q";
const authHeader = "Basic " + btoa(`${username}:${password}`);

// Reuse the fetcher and getCsrfToken functions from ViewSalesRegister
const getCsrfToken = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/session/token`,
      {
        credentials: "include",
        headers: {
          Accept: "text/plain",
        },
      },
    );

    if (response.ok) {
      const token = await response.text();
      ls.set("usercsrf_token", token);
      return token;
    }

    const storedToken = ls.get("usercsrf_token");
    if (storedToken) {
      return storedToken;
    }

    return null;
  } catch (error) {
    console.error("Error getting CSRF token:", error);
    return ls.get("usercsrf_token") || null;
  }
};

const fetcher = async (url) => {
  try {
    const csrfToken = await getCsrfToken();

    const headers = {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    };

    if (csrfToken) {
      headers["X-CSRF-Token"] = csrfToken;
    }

    const response = await fetch(url, {
      credentials: "include",
      headers: headers,
    });

    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error("Fetch error:", error);
    throw error;
  }
};

export default function EditSalesOrder() {
  const { stateNavigator, data } = useNavigationEvent();
  const saleId = data?.salesId;

  const [invoiceData, setInvoiceData] = useState(null);
  const [customerData, setCustomerData] = useState(null);
  const [cashierData, setCashierData] = useState(null);
  const [deleteProductUUID, setDeleteProductUUID] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showPaymentAddModal, setShowPaymentAddModal] = useState(false);
  const [showPaymentHistoryModal, setShowPaymentHistoryModal] = useState(false);

  // Fetch invoice data with included relationships
  const { data: invoiceResponse, error: fetchError } = useSWR(
    saleId
      ? `${process.env.REACT_APP_SALES_ORDER_API}/${saleId}?include=field_cashier,field_customer`
      : null,
    fetcher,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    },
  );
  console.log("Invoice Response:", invoiceResponse);

  const { data: invoiceorderedItems } = useSWR(
    `${process.env.REACT_APP_POS_SINGLE_ORDER_API}/${saleId}`,
    fetcher,
  );
  console.log("Order Items Single Data:", invoiceorderedItems);

  const orderedproducts = invoiceorderedItems?.order;

  // Function to delete customer
  const deteleProduct = async () => {
    if (!deleteProductUUID) {
      console.error("Invalid Product UUID");
      return;
    }

    try {
      const csrfToken = await getCsrfToken();
      if (!csrfToken) {
        alert("Authentication failed");
        return;
      }

      // Show confirmation dialog
      if (
        window.confirm(
          "Are you sure you want to delete this product? This action cannot be undone.",
        )
      ) {
        // Just send DELETE product
        const response = await fetch(
          `${process.env.REACT_APP_PRODUCT_API}/${deleteProductUUID}`,
          {
            method: "DELETE",
            headers: {
              Authorization: authHeader,
              "Content-Type": "application/vnd.api+json",
              Accept: "application/vnd.api+json",
              "X-CSRF-Token": csrfToken,
            },
            credentials: "include",
          },
        );

        if (response.ok) {
          // Show success message
          alert("Customer deleted successfully.");

          // Refresh data
          // mutateCustomers();
          // mutateProducts();
        } else if (response.status === 403) {
          // Handle deletion prevented by Drupal
          const errorData = await response.json();
          alert(`Cannot delete: ${errorData.message || "Product."}`);
        } else {
          alert(`This product cannot be deleted. Error: ${response.status}`);
        }
      }
    } catch (error) {
      console.error("Error deleting product:", error);
      alert("Error deleting product.");
    }
  };

  useEffect(() => {
    if (invoiceResponse?.data) {
      const order = invoiceResponse.data;
      setInvoiceData(order);

      // Extract included data
      if (invoiceResponse.included) {
        // Find customer data
        const customer = invoiceResponse.included.find(
          (item) => item.type === "node--customer",
        );
        if (customer) {
          setCustomerData({
            name: customer.attributes.title,
            email: customer.attributes.field_customer_email,
            phone: customer.attributes.field_phone_number,
            address: customer.attributes.field_customer_address || "N/A",
          });
        }

        // Find cashier data
        const cashier = invoiceResponse.included.find(
          (item) => item.type === "user--user",
        );
        if (cashier) {
          setCashierData({
            name: cashier.attributes.name,
            email: cashier.attributes.mail,
          });
        }
      }

      setLoading(false);
    }

    if (fetchError) {
      setError(fetchError.message);
      setLoading(false);
    }
  }, [invoiceResponse, fetchError]);

  const handlePrint = () => {
    const printContent = document.getElementById("invoice-print-content");
    const originalContent = document.body.innerHTML;

    if (printContent) {
      document.body.innerHTML = printContent.innerHTML;
      window.print();
      document.body.innerHTML = originalContent;
      window.location.reload();
    } else {
      window.print();
    }
  };

  const printThermalInvoice = async () => {
    const blob = await pdf(
      <InvoiceReceiptPdf
        invoiceData={invoiceData}
        customerData={customerData}
        items={invoiceorderedItems?.order?.items || []}
        total={total}
      />,
    ).toBlob();

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Receipt-${
      invoiceData?.attributes?.field_order_number || "invoice"
    }.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleBack = () => {
    stateNavigator.navigate("viewsalesregister");
  };

  // Handle payment success
  const handlePaymentSuccess = (result) => {
    alert(`Payment of GH₵${result.amount_paid} added successfully!`);
    // Refresh the page to show updated balance
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  // Add Payment Button Click Handler
  const handleAddPayment = () => {
    setShowPaymentAddModal(true);
  };

  // const getPaymentTypeLabel = (type) => {
  //   switch (type) {
  //     case "cash":
  //       return "Cash";
  //     case "credit_card":
  //       return "Credit Card";
  //     case "debit_card":
  //       return "Debit Card";
  //     case "mobile_money":
  //       return "Mobile Money";
  //     case "cheque":
  //       return "Cheque";
  //     default:
  //       return type.charAt(0).toUpperCase() + type.slice(1);
  //   }
  // };

  const calculateTotals = () => {
    // If we have the new API response structure (invoiceorderedItems?.order)
    if (invoiceorderedItems?.order) {
      return {
        subtotal: Number(invoiceorderedItems.order.total_amount || 0),
        tax: 0, // Add if available in API
        total: Number(invoiceorderedItems.order.total_amount || 0),
        totalPaid: Number(invoiceorderedItems.order.total_paid || 0),
        remainingBalance: Number(
          invoiceorderedItems.order.remaining_balance || 0,
        ),
        paymentStatus: invoiceorderedItems.order.payment_status || "unknown",
      };
    }

    // Fallback to old calculation if needed
    if (!orderedproducts?.items?.length) {
      return {
        subtotal: 0,
        tax: 0,
        total: 0,
        totalPaid: 0,
        remainingBalance: 0,
        paymentStatus: "unknown",
      };
    }

    const subtotal = orderedproducts?.items?.reduce((sum, item) => {
      const qty = Number(item.quantity || 0);
      const price = Number(item.unit_price || 0);
      return sum + qty * price;
    }, 0);

    const total = orderedproducts?.items?.reduce((sum, item) => {
      return sum + Number(item.line_total || 0);
    }, 0);

    const tax = 0; // change if needed later

    return {
      subtotal,
      tax,
      total,
      totalPaid: total, // Fallback: assume fully paid
      remainingBalance: 0, // Fallback: assume no balance
      paymentStatus: "paid", // Fallback status
    };
  };

  const { subtotal, tax, total, totalPaid, remainingBalance } =
    calculateTotals();

  //Thermal Receipt
  // const printThermalInvoice = async () => {
  // if (!invoiceorderedItems?.items?.length) {
  //   alert("No items to print");
  //   return;
  // }
  // const printer = new ThermalPrinter({
  //   type: PrinterTypes.EPSON,
  //   interface: "tcp://192.168.1.100", // 🔴 CHANGE to your printer IP
  //   characterSet: CharacterSet.PC437_USA,
  //   removeSpecialCharacters: false,
  //   lineCharacter: "-",
  // });
  // printer.alignCenter();
  // printer.bold(true);
  // printer.println("PROSEP SERVICES");
  // printer.bold(false);
  // printer.println("Shalom Business Centre");
  // printer.println("Achimota - Accra");
  // printer.println("Tel: 0244235128");
  // printer.newLine();
  // printer.alignLeft();
  // printer.println(`Invoice: ${invoiceData.attributes.field_order_number}`);
  // printer.println(
  //   `Date: ${new Date(invoiceData.attributes.created).toLocaleString(
  //     "en-GH"
  //   )}`
  // );
  // printer.println(`Cashier: ${cashierData?.name || "N/A"}`);
  // printer.println("--------------------------------");
  // invoiceorderedItems.items.forEach((item) => {
  //   printer.println(item.product_title);
  //   printer.println(
  //     `${item.quantity} x GH₵${Number(item.unit_price).toFixed(2)}`
  //   );
  //   printer.alignRight();
  //   printer.println(`GH₵${Number(item.line_total).toFixed(2)}`);
  //   printer.alignLeft();
  // });
  // printer.println("--------------------------------");
  // printer.alignRight();
  // printer.bold(true);
  // printer.println(`TOTAL: GH₵${total.toFixed(2)}`);
  // printer.bold(false);
  // printer.newLine();
  // printer.alignCenter();
  // printer.println("Thank you for your business");
  // printer.newLine();
  // printer.cut();
  // try {
  //   await printer.execute();
  // } catch (error) {
  //   alert("Failed to print. Ensure printer is ON and IP is reachable.");
  //   console.error(error);
  // }
  // };

  const formatGhanaPhoneNumber = (phone) => {
    if (!phone) return "N/A";

    // Remove everything except digits
    let digits = phone.replace(/\D/g, "");

    // Remove leading 0
    if (digits.startsWith("0")) {
      digits = digits.substring(1);
    }

    // Ensure country code
    if (!digits.startsWith("233")) {
      digits = `233${digits}`;
    }

    // Final: 233 24 477 0192
    if (digits.length === 12) {
      return `${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(
        5,
        8,
      )} ${digits.slice(8)}`;
    }

    return phone; // fallback if unexpected
  };

  const ghanaPhoneForWhatsApp = (phone) =>
    formatGhanaPhoneNumber(phone).replace(/\s/g, "");

  // Send WhatsApp Invoice
  const sendInvoiceViaWhatsApp = () => {
    if (!orderedproducts?.items?.length) {
      alert("No invoice items available");
      return;
    }

    // ✅ Always digits only for wa.me
    const phone = `${ghanaPhoneForWhatsApp(customerData?.phone || "")}`;

    let message = `*PANTALA LUXURY PERFUMES - RECEIPT*\n`;

    message += `Invoice #: ${invoiceData?.attributes?.field_order_number}\n`;
    message += `Date: ${new Date(
      invoiceData?.attributes?.created,
    ).toLocaleString("en-GH")}\n\n`;

    message += `Hi ${
      customerData?.name || "Customer"
    }!, Thank you for shopping with us\n\n`;
    message += `*Items:*\n`;

    invoiceorderedItems?.order?.items?.forEach((item) => {
      message += `• ${item.product_title}\n`;
      message += `  ${item.quantity} x GH₵${Number(item.unit_price).toFixed(
        2,
      )} = GH₵${Number(item.line_total).toFixed(2)}\n\n`;
    });

    message += `*Payment Summary:*\n`;
    message += `Total Amount:  GH₵${Number(total).toFixed(2)}\n`;
    message += `Total Paid:  GH₵${totalPaid.toFixed(2)}\n`;
    message += `Balance Due:  GH₵${remainingBalance.toFixed(2)}\n\n`;

    message += `View full receipt: ${process.env.REACT_APP_BASE_URL}/invoice/${saleId}\n\n`;
    message += `Thank you for your business 🙏\n`;
    message += `We hope to see you again soon! 🙏\n\n`;

    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
  };

  // Send SMS Invoice
  const handleSMS = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/pos/sms/send`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            phone: ghanaPhoneForWhatsApp(customerData?.phone || ""),
            message: `Hi ${
              customerData?.name || "Customer"
            }, Thank you for shopping at Pantala Luxury Perfumes. Receipt# ${
              invoiceData?.attributes?.field_order_number
            } - Total: ${Number(total).toFixed(
              2,
            )}. Total Paid: ${totalPaid.toFixed(
              2,
            )}. Remaining Balance: ${remainingBalance.toFixed(
              2,
            )}. We appreciate your business!. View your full receipt: ${
              process.env.REACT_APP_BASE_URL
            }/invoice/${saleId}`,
          }),
        },
      );

      if (!response.ok) {
        throw new Error("SMS failed");
      }

      alert("SMS sent successfully");
    } catch (err) {
      console.error(err);
      alert("Failed to send SMS");
    }
  };

  // Send EMAIL Invoice
  const handleEmail = () => {
    alert(
      "Email Invoice will be available soon. Use the other options for now. Thank you.",
    );
  };

  if (loading) {
    return (
      <div className="dashboard-container">
        <DashboardContentHeader />
        <div className="content-wrapper">
          <DashboardContenLeftMenus />
          <div style={styles.container}>
            <TopActionMenus
              AddTitle="Invoice Details"
              backIcon={faArrowLeft}
              backLable="Back to Register"
            />
            <div style={styles.loadingContainer}>
              <FontAwesomeIcon
                icon={faSpinner}
                spin
                size="3x"
                style={styles.loadingSpinner}
              />
              <p style={styles.loadingText}>Loading invoice details...</p>
            </div>
          </div>
        </div>
        <DashboardContentFooter />
      </div>
    );
  }

  if (error || !invoiceData) {
    return (
      <div className="dashboard-container">
        <DashboardContentHeader />
        <div className="content-wrapper">
          <DashboardContenLeftMenus />
          <div style={styles.container}>
            <TopActionMenus
              AddTitle="Invoice Details"
              buttonLabel="Back to Register"
              icon={faArrowLeft}
              onClick={handleBack}
            />
            <div style={styles.errorContainer}>
              <FontAwesomeIcon icon={faTimesCircle} style={styles.errorIcon} />
              <h3>Invoice Not Found</h3>
              <p>{error || "The requested invoice could not be found."}</p>
              <button style={styles.backButton} onClick={handleBack}>
                <FontAwesomeIcon icon={faArrowLeft} /> Back to Sales Register
              </button>
            </div>
          </div>
        </div>
        <DashboardContentFooter />
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div style={styles.container}>
          <TopActionMenus
            AddTitle="Invoice Details"
            buttonLabel="Back to Register"
            icon={faArrowLeft}
            onClick={handleBack}
          />

          {/* PRINTABLE CONTENT */}
          <div id="invoice-print-content" style={styles.printContent}>
            {/* INVOICE HEADER */}
            <div style={styles.invoiceHeader}>
              <div style={styles.companyInfo}>
                <div style={styles.companyLogo}>
                  <img
                    src={mainLogo}
                    alt="Prosep Services Logo"
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>
                <div>
                  <p style={styles.companyContact}>
                    Phone: 0244770192 / 0266090979
                    <br />
                    Email: pantalaluxuryperfumes@gmail.com
                  </p>
                </div>
              </div>

              <div style={styles.invoiceTitleContainer}>
                <h2 style={styles.invoiceTitle}>INVOICE</h2>
                <div style={styles.invoiceMeta}>
                  <div style={styles.metaItem}>
                    <span style={styles.metaLabel}>Invoice #:</span>
                    <span style={styles.metaValue}>
                      {invoiceData.attributes.field_order_number}
                    </span>
                  </div>
                  <div style={styles.metaItem}>
                    <span style={styles.metaLabel}>Order ID:</span>
                    <span style={styles.metaValue}>
                      {invoiceData.attributes.drupal_internal__nid}
                    </span>
                  </div>
                  <div style={styles.metaItem}>
                    <span style={styles.metaLabel}>Date:</span>
                    <span style={styles.metaValue}>
                      {new Date(
                        invoiceData.attributes.created,
                      ).toLocaleDateString("en-GH", {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* CUSTOMER AND PAYMENT INFO */}
            <div style={styles.infoGrid}>
              <div style={styles.infoCard}>
                <div style={styles.infoHeader}>
                  <h3 style={styles.infoTitle}>Bill To</h3>
                </div>
                {customerData ? (
                  <div style={styles.infoContent}>
                    <h4 style={styles.customerName}>{customerData.name}</h4>
                    {customerData.email && <p>Email: {customerData.email}</p>}
                    {customerData.phone && <p>Phone: {customerData.phone}</p>}
                    {customerData.address && (
                      <p>Address: {customerData.address}</p>
                    )}
                  </div>
                ) : (
                  <p>Customer information not available</p>
                )}
              </div>

              <div style={styles.infoCard}>
                <div style={styles.infoContent}>
                  {/* Payment Details */}
                  <h4 style={styles.paymentHistoryTitle}>Payment Details</h4>
                  {cashierData && (
                    <div style={styles.cashierInfo}>
                      <p>
                        <strong>Cashier:</strong> {cashierData.name}
                      </p>
                    </div>
                  )}
                  <button
                    style={styles.paymenthistorybtn}
                    onClick={() => {
                      setShowPaymentHistoryModal(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faHistory} /> Payment History
                  </button>
                </div>
              </div>
            </div>

            {/* ITEMS TABLE */}
            <div style={styles.itemsCard}>
              <div style={styles.tableContainer}>
                <table style={styles.itemsTable}>
                  <thead>
                    <tr>
                      <th style={styles.th}>#</th>
                      <th style={styles.th}>Item Name</th>
                      <th style={styles.th}>SKU</th>
                      <th style={styles.th}>Barcode</th>
                      <th style={styles.th}>Quantity</th>
                      <th style={styles.th}>Unit Price</th>
                      <th style={styles.th}>Total</th>
                      <th style={styles.th}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderedproducts?.items?.length === 0 ? (
                      <tr>
                        <td colSpan="7" style={styles.noItems}>
                          No items found in this order
                        </td>
                      </tr>
                    ) : (
                      orderedproducts?.items?.map((item, index) => (
                        <tr
                          key={item.id || index}
                          style={
                            index % 2 === 0 ? styles.evenRow : styles.oddRow
                          }
                        >
                          <td style={styles.td}>{index + 1}</td>
                          <td style={styles.td}>
                            {item.product_title || "N/A"}
                          </td>
                          <td style={styles.td}>{item.sku || "N/A"}</td>
                          <td style={styles.td}>{item.barcode || "N/A"}</td>
                          <td style={styles.td}>{item.quantity || "N/A"}</td>
                          <td style={styles.td}>
                            GH₵
                            {parseFloat(item.unit_price || 0).toFixed(2)}
                          </td>
                          <td style={styles.td}>GH₵{item.line_total}</td>
                          <td>
                            <button
                              style={styles.button}
                              onClick={() => {
                                setDeleteProductUUID(item.items.product_uuid);
                                deteleProduct();
                              }}
                              type="button"
                            >
                              <FontAwesomeIcon icon={faRemove} />
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* TOTALS */}
            <div style={styles.totalsCard}>
              <div style={styles.totalsGrid}>
                <div>
                  <div style={styles.totalsLeft}>
                    <h4 style={styles.notesTitle}>Notes</h4>
                    <p style={styles.notesText}>
                      {invoiceData.attributes.field_sales_order_notes || "N/A"}
                    </p>
                  </div>

                  {/* TERMS AND CONDITIONS */}
                  <div style={styles.termsCard}>
                    <h4 style={styles.termsTitle}>Terms and Conditions</h4>
                    <p style={styles.termsText}>
                      Information will be available soon.
                    </p>
                  </div>
                </div>

                <div style={styles.totalsRight}>
                  {/* Order Summary */}
                  <div style={styles.orderSummarySection}>
                    <h4 style={styles.summaryTitle}>Order Summary</h4>
                    <div style={styles.totalRow}>
                      <span>Subtotal:</span>
                      <span>GH₵{subtotal.toFixed(2)}</span>
                    </div>
                    <div style={styles.totalRow}>
                      <span>Tax:</span>
                      <span>GH₵{tax.toFixed(2)}</span>
                    </div>
                    {/* <div style={styles.totalDivider}></div> */}
                    <div style={styles.grandTotalRow}>
                      <span>
                        <strong>Total Amount:</strong>
                      </span>
                      <span>
                        <strong>GH₵{total.toFixed(2)}</strong>
                      </span>
                    </div>

                    {/* Payment Summary */}
                    <div style={styles.paymentSummarySection}>
                      <div style={styles.totalRow}>
                        <span>Total Paid:</span>
                        <span style={styles.paidAmount}>
                          GH₵{totalPaid.toFixed(2)}
                        </span>
                      </div>
                      <div style={styles.totalRow}>
                        <span>Balance Due:</span>
                        <span
                          style={
                            remainingBalance > 0
                              ? styles.balanceAmount
                              : styles.paidAmount
                          }
                        >
                          GH₵{remainingBalance.toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DashboardContentFooter />

      {/* Payment Add Modal */}
      {showPaymentAddModal && (
        <div className="modal">
          <div className="overlay"></div>
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-header">
                <p>Add Payment</p>
                <button
                  className="close-modal"
                  onClick={() => setShowPaymentAddModal(false)}
                >
                  <FontAwesomeIcon icon={faClose} />
                </button>
              </div>
              <PaymentModal
                isOpen={showPaymentAddModal}
                onClose={() => setShowPaymentAddModal(false)}
                orderUuid={saleId}
                balance={remainingBalance}
                onSuccess={handlePaymentSuccess}
              />
            </div>
          </div>
        </div>
      )}

      {/* Payment History Modal */}
      {showPaymentHistoryModal && (
        <div className="modal">
          <div className="overlay"></div>
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-header">
                <p>Payment History</p>
                <button
                  className="close-modal"
                  onClick={() => setShowPaymentHistoryModal(false)}
                >
                  <FontAwesomeIcon icon={faClose} />
                </button>
              </div>
              <PaymentHistory invoiceorderedItems={invoiceorderedItems} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    width: "100%",
    height: "100%",
    backgroundColor: "#ecf2fa",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
    padding: "34px 32px 4rem 32px",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "400px",
    background: "white",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  },
  loadingSpinner: {
    color: "#007bff",
    marginBottom: "20px",
  },
  loadingText: {
    color: "#666",
    fontSize: "16px",
  },
  errorContainer: {
    textAlign: "center",
    padding: "60px 20px",
    background: "white",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  },
  errorIcon: {
    fontSize: "60px",
    color: "#dc3545",
    marginBottom: "20px",
  },
  backButton: {
    background: "#007bff",
    color: "white",
    border: "none",
    padding: "12px 24px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginTop: "20px",
  },
  printContent: {
    background: "white",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    padding: "30px",
    marginBottom: "20px",
  },
  invoiceHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "30px",
    paddingBottom: "12px",
    borderBottom: "2px solid #f0f0f0",
  },
  companyInfo: {
    alignItems: "center",
    gap: "2px",
  },
  companyLogo: {
    background: "transparent",
    color: "white",
    width: "174px",
    height: "68px",
    marginBottom: "8px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  companyName: {
    margin: "0",
    fontSize: "28px",
    fontWeight: "700",
    color: "#333",
  },
  companyTagline: {
    color: "#666",
    fontSize: "14px",
  },
  companyContact: {
    color: "#666",
    fontSize: "14px",
    lineHeight: "1.2",
  },
  invoiceTitleContainer: {
    textAlign: "left",
  },
  invoiceTitle: {
    margin: "0 0 4px 40px",
    fontSize: "32px",
    fontWeight: "700",
    color: "#007bff",
  },
  invoiceMeta: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  metaItem: {
    display: "flex",
    gap: "6px",
  },
  metaLabel: {
    fontWeight: "600",
    color: "#666",
    minWidth: "100px",
    textAlign: "right",
  },
  metaValue: {
    fontWeight: "600",
    color: "#333",
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "20px",
    marginBottom: "20px",
  },
  infoCard: {
    background: "#f8f9fa",
    padding: "16px",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },
  infoHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
  },
  infoIcon: {
    color: "#007bff",
    fontSize: "20px",
  },
  infoTitle: {
    margin: "0",
    fontSize: "18px",
    color: "#333",
  },
  infoContent: {
    color: "#555",
  },
  customerName: {
    margin: "0 0 10px 0",
    fontSize: "20px",
    color: "#333",
  },
  paymentMethod: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
  },
  paymentType: {
    fontSize: "16px",
    color: "#333",
  },
  cashierInfo: {
    marginTop: "10px",
    paddingTop: "10px",
  },
  itemsCard: {
    marginBottom: "20px",
  },
  itemsIcon: {
    color: "#007bff",
    fontSize: "24px",
  },
  tableContainer: {
    overflowX: "auto",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },
  itemsTable: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    background: "#333", // Dark grey background
    padding: "12px",
    textAlign: "left",
    borderBottom: "2px solid #444", // Darker border to match
    fontWeight: "normal",
    color: "#fff", // White text
    whiteSpace: "nowrap",
  },
  td: {
    padding: "12px",
    borderBottom: "1px solid #e0e0e0",
    color: "#555",
    verticalAlign: "top",
  },
  itemDescription: {
    fontSize: "12px",
    color: "#666",
    marginTop: "4px",
    fontStyle: "italic",
  },
  noItems: {
    textAlign: "center",
    padding: "40px",
    color: "#666",
    fontStyle: "italic",
  },
  evenRow: {
    background: "#fafafa",
  },
  oddRow: {
    background: "white",
  },
  totalsCard: {
    background: "#f8f9fa",
    padding: "16px",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
    marginBottom: "20px",
  },
  totalsGrid: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    gap: "40px",
  },
  totalsLeft: {
    paddingRight: "20px",
    flex: 1,
  },
  notesTitle: {
    margin: "0 0 15px 0",
    fontSize: "18px",
    color: "#333",
    fontWeight: "600",
  },
  notesText: {
    color: "#666",
    lineHeight: "1.6",
    fontSize: "14px",
    marginBottom: "20px",
  },
  orderInfo: {
    fontSize: "14px",
    color: "#666",
  },
  totalsRight: {
    maxWidth: "400px",
  },
  totalRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
    fontWeight: "600",
    fontSize: "16px",
    color: "#666",
  },
  totalDivider: {
    height: "1px",
    background: "#e0e0e0",
    margin: "15px 0",
  },
  grandTotalRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: "15px 0",
    fontSize: "18px",
    color: "#333",
    borderTop: "2px solid #333",
  },
  apiTotal: {
    textAlign: "right",
    fontSize: "12px",
    color: "#999",
    marginTop: "5px",
  },
  actionButtons: {
    display: "flex",
    gap: "15px",
    marginTop: "20px",
  },
  printButton: {
    background: "#007bff",
    color: "white",
    border: "none",
    padding: "12px 24px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: 1,
  },
  paymenthistorybtn: {
    background: "#C2C2C2",
    color: "black",
    border: "none",
    padding: "12px 18px",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: 1,
    marginTop: "16px",
  },
  termsCard: {
    background: "#f8f9fa",
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },
  termsTitle: {
    margin: "0 0 10px 0",
    fontSize: "16px",
    color: "#333",
    fontWeight: "600",
  },
  termsText: {
    margin: "0",
    color: "#666",
    fontSize: "14px",
    lineHeight: "1.6",
  },
  paymentSummary: {
    marginBottom: "15px",
    padding: "15px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },
  paymentSummaryRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "8px",
    fontSize: "14px",
  },
  paymentAmount: {
    fontWeight: "bold",
    color: "#333",
  },
  paidAmount: {
    fontWeight: "bold",
    color: "#28a745",
  },
  balanceAmount: {
    fontWeight: "bold",
    color: "#dc3545",
  },
  paymentHistory: {
    marginTop: "15px",
    paddingTop: "15px",
    borderTop: "1px solid #e0e0e0",
  },
  paymentHistoryTitle: {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "10px",
    color: "#333",
  },
  orderSummarySection: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
  },
  summaryTitle: {
    margin: "0 0 15px 0",
    fontSize: "16px",
    color: "#333",
    fontWeight: "600",
    borderBottom: "2px solid #f0f0f0",
    paddingBottom: "8px",
  },
  paymentSummarySection: {
    paddingTop: "15px",
    borderTop: "2px solid #f0f0f0",
  },
};
